import React from 'react';
import { Trans } from '@lingui/macro';
import { Typography } from '@material-ui/core';

export const NoPmZone: React.FC<{
  /**
   * `dataTestid` - name of a No PMZone (preferably `<name>-no-pmz`)
   * @example
   * ```tsx
   * <NoPmZone {...props} dataTestid="test-no-pmz" />
   */
  dataTestId: string;
}> = ({ dataTestId }) => {
  return (
    <div className="flex justify-center items-center w-full h-full" data-testid={`${dataTestId}-wrapper`}>
      <Typography variant="h5" data-testid={`${dataTestId}-text`}>
        <Trans>Select PMZ to display information</Trans>
      </Typography>
    </div>
  );
};
